export default {
  "provider.dashboard": "Panel de control",
  "provider.products": "Mis tours",
  "provider.calendar": "Calendario",
  "provider.revenue": "Ingresos",
  "provider.bookings": "Reservas",
  "provider.reviews": "Reseñas",
  "provider.revenueToday": "Hoy",
  "provider.revenueWeek": "Esta semana",
  "provider.revenueMonth": "Este mes",
  "provider.totalBookings": "Reservas totales",
  "provider.pendingBookings": "Pendientes",
  "provider.confirmedBookings": "Confirmadas",
  "provider.avgRating": "Calificación promedio",
  "provider.newBooking": "Nueva reserva",
  "provider.noBookings": "No hay reservas recientes",
  "provider.viewAll": "Ver todas",
  "provider.mpCtaBadge": "Próximamente",
  "provider.mpCtaTitle": "Conecta tu Mercado Pago",
  "provider.mpCtaBody": "Muy pronto vas a poder recibir los pagos de tus reservas directamente en tu propia cuenta de Mercado Pago, al instante. Tú cobras directo y solo nos pagas la comisión acordada.",
  "provider.mpCtaButton": "Conectar Mercado Pago",
  "provider.mpCtaBodyLive": "Recibe los pagos de tus reservas directamente en tu propia cuenta de Mercado Pago, al instante. Tú cobras directo y solo nos pagas la comisión acordada.",
  "provider.mpConnecting": "Conectando…",
  "provider.mpConnected": "Tu cuenta de Mercado Pago quedó conectada correctamente.",
  "provider.mpCancelled": "Cancelaste la conexión con Mercado Pago. Puedes intentarlo cuando quieras.",
  "provider.mpConnectedTitle": "Mercado Pago conectado",
  "provider.mpConnectedBody": "Los pagos de tus reservas llegan directo a tu cuenta. Nosotros solo retenemos la comisión acordada.",
  "provider.mpAccount": "Cuenta",
  "provider.mpDisconnect": "Desconectar",
  "provider.mpDisconnectConfirm": "¿Desconectar tu cuenta de Mercado Pago? Los pagos de tus próximas reservas volverán a cobrarse a través de la plataforma.",
  "provider.mpReconnectBadge": "Requiere atención",
  "provider.mpReconnectTitle": "Vuelve a conectar tu Mercado Pago",
  "provider.mpReconnectBody": "La autorización de tu cuenta está por vencer o dejó de ser válida. Vuelve a conectarla para seguir recibiendo los pagos directamente.",
  "provider.mpReconnectButton": "Reconectar Mercado Pago",
  "provider.mpErr_expired_link": "El enlace de conexión caducó. Presiona «Conectar Mercado Pago» de nuevo.",
  "provider.mpErr_exchange_failed": "Mercado Pago no aceptó la conexión. Intenta otra vez; si continúa, contáctanos.",
  "provider.mpErr_account_already_linked": "Esa cuenta de Mercado Pago ya está vinculada a otro proveedor. Si no capturaste ningún dato, es porque Mercado Pago usó la sesión que ya estaba abierta en este navegador: cierra sesión en mercadopago.com.mx, o abre una ventana de incógnito, y vuelve a intentarlo con la cuenta del proveedor.",
  "provider.mpErr_not_configured": "La conexión con Mercado Pago aún no está habilitada en la plataforma.",
  "provider.mpErr_platform_account": "Autorizaste la cuenta de Mercado Pago de la plataforma, no la del proveedor. Cierra sesión en mercadopago.com.mx o usa una ventana de incógnito, y vuelve a intentarlo iniciando sesión con la cuenta del proveedor.",
  "provider.mpErr_unknown": "No pudimos completar la conexión. Intenta de nuevo.",
  "provider.mpCtaSoon": "Disponible muy pronto",
  "provider.addTour": "Nuevo tour",
  "provider.editTour": "Editar",
  "provider.deleteTour": "Eliminar",
  "provider.tourName": "Nombre del tour",
  "provider.category": "Categoría",
  "provider.price": "Precio",
  "provider.status": "Estado",
  "provider.active": "Activo",
  "provider.paused": "Pausado",
  "provider.draft": "Borrador",
  "provider.save": "Guardar",
  "provider.cancel": "Cancelar",
  "provider.description": "Descripción",
  "provider.duration": "Duración",
  "provider.maxGuests": "Máx. viajeros",
  "provider.languages": "Idiomas",
  "provider.images": "Imágenes",
  "provider.uploadImage": "Subir imagen",
  "provider.included": "Incluido",
  "provider.notIncluded": "No incluido",
  "provider.meetingPoint": "Punto de encuentro",
  "provider.cancellation": "Política de cancelación",
  "provider.itinerary": "Itinerario",
  "provider.addStep": "Agregar paso",
  "provider.time": "Hora",
  "provider.stepTitle": "Título",
  "provider.stepDesc": "Descripción",
  "provider.sun": "Dom",
  "provider.mon": "Lun",
  "provider.tue": "Mar",
  "provider.wed": "Mié",
  "provider.thu": "Jue",
  "provider.fri": "Vie",
  "provider.sat": "Sáb",
  "provider.availability": "Disponibilidad",
  "provider.blockDate": "Bloquear fecha",
  "provider.unblockDate": "Desbloquear",
  "provider.booked": "Reservado",
  "provider.available": "Disponible",
  "provider.blocked": "Bloqueado",
  "provider.welcome": "¡Bienvenido!",
  "provider.onboardingDesc": "Completa estos pasos para empezar a vender tours",
  "provider.companyName": "Nombre de la empresa",
  "provider.companyAddress": "Dirección fiscal",
  "provider.upload": "Subir",
  "provider.bank": "Banco",
  "provider.website": "Sitio web",
  "provider.onboardingComplete": "¡Todo listo!",
  "provider.onboardingCompleteDesc": "Ya puedes crear tu primer tour y empezar a recibir reservas.",
  "provider.createFirstTour": "Crear mi primer tour",
  "provider.back": "Anterior",
  "provider.continue": "Continuar",
  "provider.customer": "Cliente",
  "provider.tour": "Tour",
  "provider.date": "Fecha",
  "provider.reviewsReceived": "Reseñas recibidas",
  "provider.replied": "Respondida",
  "provider.replyPlaceholder": "Escribe tu respuesta...",
  "provider.sendReply": "Enviar respuesta",
  "provider.reply": "Responder",
  "provider.earnings": "Ingresos y pagos",
  "provider.totalEarnings": "Ingresos totales",
  "provider.pendingPayout": "Pago pendiente",
  "provider.commissionPaid": "Comisión pagada",
  "provider.revenueChart": "Gráfico de ingresos",
  "provider.settlements": "Liquidaciones",
  "provider.companyProfile": "Perfil de empresa",
  "provider.verification": "Verificación",
  "provider.bankAccount": "Cuenta bancaria",
  "provider.bookingSettings": "Configuración de reservas",
  "provider.autoConfirm": "Confirmación automática",
  "provider.autoConfirmDesc": "Las reservas se confirman sin revisión manual",
  "provider.instantBooking": "Reserva instantánea",
  "provider.instantBookingDesc": "Permitir reservas sin aprobación previa",
  "provider.minNotice": "Antelación mínima",
  "provider.hours": "horas",
  "provider.notificationSettings": "Notificaciones",
  "provider.emailBookings": "Nuevas reservas",
  "provider.emailBookingsDesc": "Recibir correo cuando haya una nueva reserva",
  "provider.emailReviews": "Nuevas reseñas",
  "provider.emailReviewsDesc": "Recibir correo cuando dejen una reseña",
  "provider.emailPayments": "Pagos recibidos",
  "provider.emailPaymentsDesc": "Recibir correo cuando se procese un pago",
  "provider.language": "Idioma",
  "provider.notifications": "Notificaciones",
  "provider.settings": "Configuración",
  "provider.rating": "Calificación",
  "provider.activeTours": "Tours activos",
  "provider.netTotal": "Neto total",
  "provider.loading": "Cargando…",
  "provider.noData": "Sin datos todavía",
  "provider.loadError": "No pudimos cargar el panel.",
  "provider.profileLoadError": "No pudimos cargar los datos de tu empresa. Recarga la página antes de editar.",
  "provider.profileSaveError": "No pudimos guardar los cambios. Inténtalo de nuevo.",
  "provider.companyNameRequired": "El nombre de la empresa es obligatorio.",
  "provider.colRef": "Ref",
  "provider.colClient": "Cliente",
  "provider.colTour": "Tour",
  "provider.colDate": "Fecha",
  "provider.colTotal": "Total",
  "provider.colStatus": "Estado",
  "provider.statusColumn": "Estado",
  "provider.bookingsColumn": "Reservas",
  "provider.verifiedCustomer": "Cliente verificado",
  "provider.noReviewsYet": "Aún no tienes reseñas. Cuando tus clientes completen sus tours podrán dejarte una.",
  "provider.loadReviewsError": "No pudimos cargar tus reseñas.",
  "provider.reviewsApproved": "Reseñas aprobadas",
  "provider.reviewsTotal": "Total",
  "provider.reviewPending": "Pendiente",
  "provider.reviewRejected": "Rechazada",
  "provider.bookingId": "ID",
  "provider.guestsColumn": "Huéspedes",
  "provider.totalColumn": "Total",
  "provider.netColumn": "Neto",
  "provider.noMatches": "Sin coincidencias con los filtros actuales.",
  "provider.topTours": "Tours con más ingresos",
  "provider.monthlyBreakdown": "Detalle mensual",
  "provider.period": "Periodo",
  "provider.gross": "Ventas brutas",
  "provider.commissionColumn": "Comisión",
  "provider.net": "Neto",
  "provider.bookingsCount": "reservas",
  "provider.noRevenueYet": "Aún no hay ingresos para graficar.",
  "provider.statusConfirmed": "Confirmada",
  "provider.statusPending": "Pendiente",
  "provider.statusCompleted": "Completada",
  "provider.statusCancelled": "Cancelada",
  "provider.archived": "Archivado",
  "provider.archiveTour": "Archivar",
  "provider.archiveConfirm": "¿Archivar este tour? Dejará de aparecer en el catálogo.",
  "provider.archiveError": "No pudimos archivar el tour.",
  "provider.archivingEllipsis": "Archivando…",
  "provider.noProductsYet": "Aún no tienes tours publicados. Crea el primero.",
  "provider.calTourLabel": "Tour:",
  "provider.calPrevMonth": "Mes anterior",
  "provider.calNextMonth": "Siguiente mes",
  "provider.calAvailable": "Disponible",
  "provider.calLimited": "Pocos cupos",
  "provider.calFull": "Lleno",
  "provider.calClosed": "Cerrado",
  "provider.calNotSet": "Sin configurar",
  "provider.calToday": "Hoy",
  "provider.calConfigureTitle": "Configurar disponibilidad",
  "provider.calCapacityLabel": "Cupo total",
  "provider.calCapacityHint": "Pon 0 para cerrar ese día. Si ya hay reservas, la capacidad no puede bajar de las {{count}} ya reservadas.",
  "provider.calStartTimeLabel": "Hora de salida (opcional)",
  "provider.calPriceOverrideLabel": "Precio especial del día (MXN, opcional)",
  "provider.calPriceOverridePlaceholder": "Usa el precio normal del tour",
  "provider.calCancel": "Cancelar",
  "provider.calSave": "Guardar",
  "provider.calLoadToursError": "No pudimos cargar tus tours.",
  "provider.calLoadAvailError": "No pudimos cargar la disponibilidad.",
  "provider.calSaveError": "No pudimos guardar.",
  "provider.calCapacityValidation": "La capacidad debe ser un número ≥ 0.",
  "provider.calAvailableCount": "{{count}} disponibles",
  "provider.calBookedCount": "{{count}} reservados",

  // Shared
  "provider.saving": "Guardando…",
  "provider.savedShort": "Guardado.",

  // Onboarding / verificación de documentos
  "provider.onb.title": "Verificación de proveedor",
  "provider.onb.desc": "Sube tus documentos para que el equipo verifique tu cuenta. Acepta fotos (JPG/PNG/WebP) o PDF.",
  "provider.onb.ine": "INE",
  "provider.onb.ineHint": "Identificación oficial vigente",
  "provider.onb.proof": "Comprobante de domicilio",
  "provider.onb.proofHint": "No mayor a 3 meses",
  "provider.onb.curp": "CURP",
  "provider.onb.curpHint": "Clave Única de Registro de Población",
  "provider.onb.acta": "Acta constitutiva",
  "provider.onb.actaHint": "Solo personas morales (opcional)",
  "provider.onb.verified": "Verificado",
  "provider.onb.rejected": "Rechazado",
  "provider.onb.pending": "En revisión",
  "provider.onb.replace": "Reemplazar",
  "provider.onb.uploadShort": "Subir",
  "provider.onb.uploading": "Subiendo…",
  "provider.onb.delete": "Eliminar",
  "provider.onb.uploadError": "No se pudo subir el archivo.",
  "provider.onb.editCompany": "Editar datos de la empresa →",

  // Notificaciones (feed)
  "provider.notif.all": "Todas",
  "provider.notif.unread": "No leídas",
  "provider.notif.markAllRead": "Marcar todas leídas",
  "provider.notif.empty": "No tienes notificaciones.",
  "provider.notif.justNow": "Justo ahora",
  "provider.notif.minsAgo": "Hace {{n}} min",
  "provider.notif.hoursAgo": "Hace {{n}} h",
  "provider.notif.daysAgo": "Hace {{n}} d",

  // Configuración de reservas
  "provider.cfg.title": "Configuración de reservas",
  "provider.cfg.desc": "Ajusta cómo aceptas reservas para tus tours.",
  "provider.cfg.minDays": "Anticipación mínima de reserva (días)",
  "provider.cfg.minDaysHint": "Los clientes no podrán reservar con menos de estos días de anticipación. 0 = sin mínimo.",
  "provider.cfg.range": "Indica un número entre 0 y 365.",
  "provider.cfg.saveError": "No se pudo guardar.",

  // Sidebar / perfil de empresa
  "provider.company": "Empresa",
  "provider.verified": "Proveedor verificado",
  "provider.suspended": "Cuenta suspendida",
  "provider.pendingVerification": "Pendiente de verificación",
  "provider.saved": "Guardado",
  "provider.phone": "Teléfono",
  "provider.email": "Correo electrónico",

  // Reservas
  "provider.all": "Todas",

  // Calendario (clave dinámica del leyenda)
  "provider.calNoConfig": "Sin configurar",

  // Formulario de tour (ProductForm)
  "provider.formSectionBasics": "Básicos",
  "provider.formTitle": "Título del tour",
  "provider.formCategory": "Categoría",
  "provider.formLocation": "Ubicación",
  "provider.formDesc": "Descripción",
  "provider.formItinerary": "Itinerario",
  "provider.formItineraryHint": "Un recuadro por concepto. La hora es opcional.",
  "provider.formItineraryTime": "8:00",
  "provider.formItineraryStep": "Salida",
  "provider.formItineraryAdd": "Agregar paso",
  "provider.formItineraryRemove": "Eliminar paso",
  "provider.formMeetingPoint": "Punto de encuentro",
  "provider.formDuration": "Duración",
  "provider.formDurationPlaceholder": "8 horas",
  "provider.formLanguages": "Idiomas",
  "provider.formSectionPricing": "Precio y capacidad",
  "provider.formPriceAdult": "Precio adulto (MXN)",
  "provider.formPriceChild": "Precio niño (opcional)",
  "provider.formMaxGuests": "Máximo huéspedes",
  "provider.formSectionMedia": "Imágenes",
  "provider.formMediaHelp": "Sube imágenes desde tu computadora o pega URLs. La primera será la portada. Máx 5 MB por imagen (JPG, PNG, WebP).",
  "provider.formMediaUpload": "Subir desde mi computadora",
  "provider.orPasteUrl": "O pega una URL",
  "provider.formMediaAdd": "Agregar",
  "provider.formMediaEmpty": "Sin imágenes todavía.",
  "provider.formSectionPublish": "Publicación",
  "provider.statusActiveDesc": "Visible en el catálogo y aceptando reservas.",
  "provider.statusPausedDesc": "Oculto del catálogo. Las reservas existentes no se afectan.",
  "provider.formCancel": "Cancelar",
  "provider.formSave": "Guardar cambios",
  "provider.formPublish": "Publicar tour",
  "provider.uploading": "Subiendo…",
  "provider.uploadError": "No pudimos subir la imagen.",
  "provider.required": "Requerido",
  "provider.descMin": "La descripción debe tener al menos 20 caracteres.",
  "provider.priceInvalid": "Precio inválido",
  "provider.maxGuestsMin": "Al menos 1",
  "provider.saveError": "No pudimos guardar. Inténtalo de nuevo.",

  // Productos (nuevo / editar)
  "provider.backToProducts": "Volver a productos",
  "provider.tourNotFound": "Tour no encontrado.",
};